var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "1080",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "채용공고 목록",
      "showsFilterButton": ""
    },
    model: {
      value: _vm.showsSearch,
      callback: function ($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('recruitment-list-search', _vm._b({}, 'recruitment-list-search', {
    showsSearch: _vm.showsSearch
  }, false)), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.company`,
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('span', [_vm._v(" " + _vm._s((value === null || value === void 0 ? void 0 : value.name) || "-") + " (" + _vm._s((value === null || value === void 0 ? void 0 : value.username) || "-") + ") ")])];
      }
    }, {
      key: `item.subject`,
      fn: function (_ref3) {
        var _item$host;
        var item = _ref3.item,
          value = _ref3.value;
        return [_c('v-list-item', {
          attrs: {
            "href": `/recruitments/${item._id}`
          }
        }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s((_item$host = item.host) === null || _item$host === void 0 ? void 0 : _item$host.name) + " ")]), _c('v-list-item-title', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s(value) + " ")]), _c('p', {
          staticClass: "mt-2 mb-0 text-truncate"
        }, [_vm._v(_vm._s(item.summary))])], 1)], 1)];
      }
    }, {
      key: `item.state`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-select', _vm._b({
          staticClass: "text-caption",
          on: {
            "input": function (state) {
              return _vm.update({
                _id: item._id,
                state
              });
            }
          },
          model: {
            value: item.state,
            callback: function ($$v) {
              _vm.$set(item, "state", $$v);
            },
            expression: "item.state"
          }
        }, 'v-select', Object.assign({}, _vm.attrs_input__verticalTable, {
          items: _vm.states
        }), false))];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-btn', {
          attrs: {
            "x-small": "",
            "fab": "",
            "text": "",
            "icon": "",
            "tile": "",
            "to": `/console/recruitment/list/${item._id}/statistics`
          }
        }, [_c('v-icon', [_vm._v("mdi-chart-line")])], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }